
import React from 'react'
import { Helmet } from 'react-helmet';
import Page from '../Page'
import ProjectGroup from '../../models/ProjectGroup';
import { CheckBox } from '../../components/form/CheckboxInput';

const descriptions = {
    'Project Brief': 'Actions relating to creating projects, editing project briefs and adding/removing roles included in the search.',
    'Talent Selection': 'Actions related to viewing, short-listing and selecting talent for a particular project.',
    'SoW': 'Actions related to managing the Statement of Work (SoW) for a project including requesting the SoW, making edits and signing.',
}

export default class MyGroups extends Page {
    static path = '/client/my-groups';

    render() {
        if (!this.context?.auth) {
            return null
        }
        const groups = this.context?.auth?.client_project_groups || [];

        return (
            <>
                <Helmet>
                    <title>My Groups | Wripple</title>
                </Helmet>
                <div className='container-fluid'>
                    <div className='form-container' style={styles.formContainer}>

                        <div style={styles.myGroupsContainer} className="bordered-panel">
                            <h2>My Groups</h2>
                            <p className="py-2">Groups are used within the Wripple platform to manage workflow, project visibility and permissions across company users. You are currently a member of the groups shown below. Please contract your Wripple admin to request changes to groups you belong to or permissions within the group(s).</p>
                            <div className="invite-user-project-group-container bt">
                                {groups.map(group => {
                                    return (
                                        <div className="project-group-category" key={group.id}>
                                            <p className="m-0">Group: <strong>{group.name}</strong></p>
                                            <div className="grouped-permissions">
                                                {TB.map(ProjectGroup.GroupedPermissions, (perm, groupLabel) => {
                                                    return (
                                                        <div key={groupLabel} className="grouped-section">

                                                            <div>

                                                                <div className="grouped-title">{groupLabel}</div>
                                                                <p className="grouped-description">{descriptions[groupLabel]}</p>

                                                            </div>
                                                            <div>

                                                                {TB.map(perm, (key, label) => {
                                                                    return (
                                                                        <div className="single-permission" key={label}>
                                                                            <CheckBox
                                                                                name={key}
                                                                                disabled
                                                                                value={!!group?.[key]}
                                                                                label={label}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}


// style overrides
const styles = {
    formContainer: {
        paddingBottom: 60
    },
    myGroupsContainer: {
        maxWidth: 1000,
        padding: '26px 5%',
        background: 'white',
    },
}
